{
  "static-content-online-booking-process": {
    "buttons": {},
    "text": {
      "title": "Booking online is a breeze!",
      "description": "Find the salon of your choice and select your preferred service, date and time. Confirm your details and you're all set!",
      "step-confirm-title": "That's it",
      "step-confirm-description": "You will receive instant a booking confirmation and you're all set",
      "step-find-salon-title": "Find salon",
      "step-find-salon-description": "Find the salon by location, treatment or date",
      "step-select-date-title": "Select date and time",
      "step-select-date-description": "You can select any available date and time",
      "step-select-service-title": "Select service",
      "step-select-service-description": "Choose your preferred service"
    }
  }
}
